export default {"src":"/_next/static/media/0xa184088a740c695e156f91f5cc086a06bb78b827.8c09271a.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};